import { forwardRef, useEffect, useState } from 'react'
import { EyeClosedIcon, EyeOpenIcon } from '../../icon'
import { BaseInput, InputSize, InputType } from '../base'
import type { PasswordInputProps } from './types'

export { InputVariant } from '../base'


const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ hidden = true, ...props }, ref) => {
    const [hiddenValue, setHiddenValue] = useState(hidden)
    const handleHiddenChange = () => setHiddenValue((currentHiddenValue) => !currentHiddenValue)
    const type = !hiddenValue ? InputType.text : InputType.password
    useEffect(() => {
      setHiddenValue(hidden)
    }, [hidden])

    const TrailIcon = !hiddenValue ? EyeClosedIcon : EyeOpenIcon
    const TrailingAccessory = <TrailIcon onClick={handleHiddenChange} outline />
    return (
      <BaseInput
        {...props}
        ref={ref}
        size={InputSize.medium}
        className={'password-input'}
        trailingAccessory={TrailingAccessory}
        type={type}
      />
    )
  }
)
PasswordInput.displayName = 'PasswordInput'
export default PasswordInput
